import { render, staticRenderFns } from "./newRule.vue?vue&type=template&id=84789fe2&scoped=true"
import script from "./newRule.vue?vue&type=script&lang=js"
export * from "./newRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84789fe2",
  null
  
)

export default component.exports